import React from 'react';
import '../stylesheets/ArticleSection.scss';

export default function ArticleSection(props) {
  function printCopy() {
    return props.copy
      .filter((val) => val.section === props.sectionNumber)
      .map((val) => {
        return (
          <section key={val.section} className="article-section">
            {val.content.title}
            {val.content.table}
            <div className="article-section-content">
              {val.content.paragraph.map((paragraph, index) => {
                return <React.Fragment key={index}>{paragraph}</React.Fragment>;
              })}
            </div>
          </section>
        );
      });
  }

  return <div className="article-section-container">{printCopy()}</div>;
}
